import {
  organizationOptimizationTypes,
  organizationServiceTypes,
} from "./Organization";

export type OrganizationServiceType = (typeof organizationServiceTypes)[number];

export const optimizationText: {
  [k in OrganizationServiceType]: string;
} = {
  optium: "最適化",
  planium: "自動ドラフト",
};

export const dummyOptmizeResponse = {
  doc_id: "XuQUhB4rK7QaSI0QlzFStVg0zIE2",
  version: "1239819741927391821",
  title: "2022/08/24 在庫リスク検証",
  published_at: "2022-08-24T23:47:28Z",
  published_by_operation: "create",
  published_by_user_uid: "wiejfijviwje",
  last_modified_at: "2022-08-24T23:47:28Z",
  last_modified_by_user_uid: "wiejfiajeifjwi",
  comment: "comment",
  schema_version: "schema.version.1",
  optimize_weight_type: "バランス",
  optimize_algorithm_version: "v1.0.1",
  optimize_status: "in_progress",
  optimize_finished_at: "2022-08-24T23:47:28Z",
  optimize_from_version: "1239819741927391821",
  optimize_job_id: "129381975917",
  optimize_job_dir: "gs://path/to/file",
  optimize_job_bucket_name: "${BUCKET_NAME}",
  optimize_job_working_dir: "${ORG_ID}/${YYYY-MM-DD}/${CASE_ID}",
  optimize_job_input_file_path:
    "${ORG_ID}/${YYYY-MM-DD}/${CASE_ID}/input/${FILE_NAME}",
  optimize_job_output_result_file_path:
    "${ORG_ID}/${YYYY-MM-DD}/${CASE_ID}/output/result.json",
  optimize_job_output_report_file_path:
    "${ORG_ID}/${YYYY-MM-DD}/${CASE_ID}/output/report.json",
  plan_score_by_hand: 3,
  category: true,
  edited_users_uids: null,
  created_at: "2022-08-24T23:47:28Z",
  updated_at: "2022-08-24T23:47:28Z",
  is_disabled: false,
};

export type OptimizeResponseRaw = typeof dummyOptmizeResponse;

export type OptimizeFormRaw = {
  target_version: string;
  algorithm_version: string;
  title: string;
  comment: string;
  save_type: (typeof organizationOptimizationTypes)[number];
};

// 最適化・評価APIに渡す、DB未反映の入力パラメータ差分
export type OptimizeInputParametersRaw = {
  [sheetId: string]: {
    rows: {
      sheet_data_cells: { [fieldId: string]: string };
    }[];
  };
};

// APIサーバーではcategoryはnullableだが、未分類の場合は空文字列を渡す
export type OptimizeFormFile = Pick<
  OptimizeFormRaw,
  "title" | "comment" | "algorithm_version"
> & {
  file: File;
  category: string;
};
